import React from 'react';
import { IconSvgProps } from '@models/common';

const Collapse: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 19L9.94972 14.0503M19 5L14.0503 9.94972M5 13L9.93934 13C10.5251 13 11 13.4749 11 14.0607L11 19M13 5L13 9.93934C13 10.5251 13.4749 11 14.0607 11H19'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Collapse;
